import { TenantInfo } from '../../models'

export const DEFAULT_INFO = (mail: string): TenantInfo => ({
  mail,
  phone: '',
  street: '',
  postcode: '',
  city: '',
  logoUrl: 'https://xeetr.de/img/xeetr-logo.png',
  timezone: 'Europe/Berlin',
})
